<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="4">
					<!--캠페인명-->
					<sf-input-group
						:label="getMessage_('QWCC001007')"
						:inputValue="cmpnMstSearchParams.cmpnNo"
						:onChange="value => onChangeSearchParam({ key: 'cmpnNo', value })"
					/>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/mqy/ceqi/RoApcn/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},

	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		searchList() {
			this.$sf_toggleLoading(true);
			this.getCmpnMstList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		onChangeSearchParam({ key, value }) {
			this.setCmpnMstSearchParam_({ key, value });
		}
	},
	async created() {
		try {
			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
